import React from 'react';
import SurveyGroupQuestionRow from './SurveyGroupQuestionRow/index';

const SurveyGroupQuestionList = ({
    surveyQuestionList,
    selectedSurveyGroup,
    onDeleteSurveyGroupQuestion,
    showSurveyQuestionLoader
}) => {
    return (
        <div className="app-main-content">
            {selectedSurveyGroup ?.questions ?. length > 0 ? selectedSurveyGroup.questions.map((data, index) =>
                <SurveyGroupQuestionRow
                    key={index}
                    surveyGroupQuestionId={data}
                    surveyGroupQuestionText={surveyQuestionList[data]} // only required if we want to show the question content
                    onDeleteSurveyGroupQuestion={onDeleteSurveyGroupQuestion}
                    showSurveyQuestionLoader={showSurveyQuestionLoader}
                />
            ) : null}

        </div>
    );
};

export default SurveyGroupQuestionList;


// WEBPACK FOOTER //
// ./components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/index.js